
    var ret = {
      defaultLocale: "en-US",
      fallbackLocale: "en-US",
      availableLocales: ["af-ZA","ar-AE","da","de","de-CH","en-US","es","fi-FI","fr-FR","hu","id-ID","it-IT","ja-JP","nb-NO","nl-NL","pl","pt-BR","ro","ru","sk-SK","sv","tr-TR","zh-CN"],
      bundled: {},
      loadables: {},
    };

  // Bundled locales are directly available in the main bundle.
  
    {
      var suffixes = [".ftl"];
      var contents = [];
    
      contents.push(require("/usr/src/app/locales/en-US/common.ftl").default);
    

      contents.push(require("/usr/src/app/locales/en-US/framework.ftl").default);
    

      contents.push(require("/usr/src/app/locales/en-US/ui.ftl").default);
    
      contents = contents.concat(suffixes.map(function(suffix) { return require("/usr/src/app/locales/en-US/auth" + suffix).default; }));
      ret.bundled["en-US"] = contents.join("\n");
    }
  

  // Loadables are in a separate bundle, that can be easily loaded.
  
    ret.loadables["af-ZA"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-af-ZA", webpackMode: "lazy" */
          "/usr/src/app/locales/af-ZA/framework.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-af-ZA", webpackMode: "lazy-once" */
          "/usr/src/app/locales/af-ZA/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["ar-AE"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-ar-AE", webpackMode: "lazy" */
          "/usr/src/app/locales/ar-AE/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-ar-AE", webpackMode: "lazy" */
          "/usr/src/app/locales/ar-AE/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-ar-AE", webpackMode: "lazy" */
          "/usr/src/app/locales/ar-AE/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-ar-AE", webpackMode: "lazy-once" */
          "/usr/src/app/locales/ar-AE/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["da"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-da", webpackMode: "lazy" */
          "/usr/src/app/locales/da/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-da", webpackMode: "lazy" */
          "/usr/src/app/locales/da/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-da", webpackMode: "lazy" */
          "/usr/src/app/locales/da/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-da", webpackMode: "lazy-once" */
          "/usr/src/app/locales/da/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["de"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-de", webpackMode: "lazy" */
          "/usr/src/app/locales/de/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-de", webpackMode: "lazy" */
          "/usr/src/app/locales/de/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-de", webpackMode: "lazy" */
          "/usr/src/app/locales/de/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-de", webpackMode: "lazy-once" */
          "/usr/src/app/locales/de/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["de-CH"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-de-CH", webpackMode: "lazy" */
          "/usr/src/app/locales/de-CH/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-de-CH", webpackMode: "lazy" */
          "/usr/src/app/locales/de-CH/framework.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-de-CH", webpackMode: "lazy-once" */
          "/usr/src/app/locales/de-CH/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["es"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-es", webpackMode: "lazy" */
          "/usr/src/app/locales/es/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-es", webpackMode: "lazy" */
          "/usr/src/app/locales/es/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-es", webpackMode: "lazy" */
          "/usr/src/app/locales/es/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-es", webpackMode: "lazy-once" */
          "/usr/src/app/locales/es/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["fi-FI"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-fi-FI", webpackMode: "lazy" */
          "/usr/src/app/locales/fi-FI/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-fi-FI", webpackMode: "lazy" */
          "/usr/src/app/locales/fi-FI/framework.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-fi-FI", webpackMode: "lazy-once" */
          "/usr/src/app/locales/fi-FI/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["fr-FR"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-fr-FR", webpackMode: "lazy" */
          "/usr/src/app/locales/fr-FR/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-fr-FR", webpackMode: "lazy" */
          "/usr/src/app/locales/fr-FR/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-fr-FR", webpackMode: "lazy" */
          "/usr/src/app/locales/fr-FR/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-fr-FR", webpackMode: "lazy-once" */
          "/usr/src/app/locales/fr-FR/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["hu"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-hu", webpackMode: "lazy" */
          "/usr/src/app/locales/hu/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-hu", webpackMode: "lazy" */
          "/usr/src/app/locales/hu/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-hu", webpackMode: "lazy" */
          "/usr/src/app/locales/hu/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-hu", webpackMode: "lazy-once" */
          "/usr/src/app/locales/hu/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["id-ID"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-id-ID", webpackMode: "lazy" */
          "/usr/src/app/locales/id-ID/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-id-ID", webpackMode: "lazy" */
          "/usr/src/app/locales/id-ID/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-id-ID", webpackMode: "lazy" */
          "/usr/src/app/locales/id-ID/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-id-ID", webpackMode: "lazy-once" */
          "/usr/src/app/locales/id-ID/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["it-IT"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-it-IT", webpackMode: "lazy" */
          "/usr/src/app/locales/it-IT/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-it-IT", webpackMode: "lazy" */
          "/usr/src/app/locales/it-IT/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-it-IT", webpackMode: "lazy" */
          "/usr/src/app/locales/it-IT/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-it-IT", webpackMode: "lazy-once" */
          "/usr/src/app/locales/it-IT/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["ja-JP"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-ja-JP", webpackMode: "lazy" */
          "/usr/src/app/locales/ja-JP/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-ja-JP", webpackMode: "lazy" */
          "/usr/src/app/locales/ja-JP/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-ja-JP", webpackMode: "lazy" */
          "/usr/src/app/locales/ja-JP/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-ja-JP", webpackMode: "lazy-once" */
          "/usr/src/app/locales/ja-JP/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["nb-NO"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-nb-NO", webpackMode: "lazy" */
          "/usr/src/app/locales/nb-NO/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-nb-NO", webpackMode: "lazy" */
          "/usr/src/app/locales/nb-NO/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-nb-NO", webpackMode: "lazy" */
          "/usr/src/app/locales/nb-NO/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-nb-NO", webpackMode: "lazy-once" */
          "/usr/src/app/locales/nb-NO/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["nl-NL"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-nl-NL", webpackMode: "lazy" */
          "/usr/src/app/locales/nl-NL/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-nl-NL", webpackMode: "lazy" */
          "/usr/src/app/locales/nl-NL/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-nl-NL", webpackMode: "lazy" */
          "/usr/src/app/locales/nl-NL/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-nl-NL", webpackMode: "lazy-once" */
          "/usr/src/app/locales/nl-NL/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["pl"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-pl", webpackMode: "lazy" */
          "/usr/src/app/locales/pl/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-pl", webpackMode: "lazy" */
          "/usr/src/app/locales/pl/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-pl", webpackMode: "lazy" */
          "/usr/src/app/locales/pl/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-pl", webpackMode: "lazy-once" */
          "/usr/src/app/locales/pl/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["pt-BR"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-pt-BR", webpackMode: "lazy" */
          "/usr/src/app/locales/pt-BR/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-pt-BR", webpackMode: "lazy" */
          "/usr/src/app/locales/pt-BR/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-pt-BR", webpackMode: "lazy" */
          "/usr/src/app/locales/pt-BR/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-pt-BR", webpackMode: "lazy-once" */
          "/usr/src/app/locales/pt-BR/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["ro"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-ro", webpackMode: "lazy" */
          "/usr/src/app/locales/ro/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-ro", webpackMode: "lazy" */
          "/usr/src/app/locales/ro/framework.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-ro", webpackMode: "lazy-once" */
          "/usr/src/app/locales/ro/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["ru"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-ru", webpackMode: "lazy" */
          "/usr/src/app/locales/ru/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-ru", webpackMode: "lazy" */
          "/usr/src/app/locales/ru/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-ru", webpackMode: "lazy" */
          "/usr/src/app/locales/ru/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-ru", webpackMode: "lazy-once" */
          "/usr/src/app/locales/ru/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["sk-SK"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-sk-SK", webpackMode: "lazy" */
          "/usr/src/app/locales/sk-SK/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-sk-SK", webpackMode: "lazy" */
          "/usr/src/app/locales/sk-SK/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-sk-SK", webpackMode: "lazy" */
          "/usr/src/app/locales/sk-SK/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-sk-SK", webpackMode: "lazy-once" */
          "/usr/src/app/locales/sk-SK/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["sv"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-sv", webpackMode: "lazy" */
          "/usr/src/app/locales/sv/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-sv", webpackMode: "lazy" */
          "/usr/src/app/locales/sv/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-sv", webpackMode: "lazy" */
          "/usr/src/app/locales/sv/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-sv", webpackMode: "lazy-once" */
          "/usr/src/app/locales/sv/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["tr-TR"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-tr-TR", webpackMode: "lazy" */
          "/usr/src/app/locales/tr-TR/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-tr-TR", webpackMode: "lazy" */
          "/usr/src/app/locales/tr-TR/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-tr-TR", webpackMode: "lazy" */
          "/usr/src/app/locales/tr-TR/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-tr-TR", webpackMode: "lazy-once" */
          "/usr/src/app/locales/tr-TR/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["zh-CN"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "auth-locale-zh-CN", webpackMode: "lazy" */
          "/usr/src/app/locales/zh-CN/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-zh-CN", webpackMode: "lazy" */
          "/usr/src/app/locales/zh-CN/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "auth-locale-zh-CN", webpackMode: "lazy" */
          "/usr/src/app/locales/zh-CN/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "auth-locale-zh-CN", webpackMode: "lazy-once" */
          "/usr/src/app/locales/zh-CN/auth" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  
    module.exports = ret;
  